/* Block - Testimonial.
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 */
/* eslint-disable-next-line */
import styles from "./block-testimonial.scss";

import rsCarousel from '../../js/component/_carousel';

const carousels = document.querySelectorAll('body:not(.wp-admin) .rs-carousel');

rsCarousel.init(carousels);
